import { createRouter, createWebHistory } from 'vue-router';
// 1. Am SCOS importul pentru Auth.vue

import Login from '../components/Login.vue';
import Register from '../components/Register.vue';

// Importă noul layout și paginile
import MainLayout from '../components/MainLayout.vue';
import EventList from '../components/EventList.vue'; 
import MyEvents from '../components/MyEvents.vue';
import PastEvents from '../components/PastEvents.vue';
import UserList from '../components/UserList.vue'; 
import AdminPanel from '../components/AdminPanel.vue'; 
import SendNotification from '../components/SendNotification.vue';
import NewsFeed from '../components/NewsFeed.vue';

// --- IMPORTĂ COMPONENTA NOUĂ AICI ---
import CreatePost from '../components/CreatePost.vue';

const routes = [
  {
    // 2. Ruta /auth merge acum DIRECT la Login.vue
    path: '/auth',
    name: 'Login',
    component: Login,
    meta: { requiresGuest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: { requiresGuest: true }
  },
  {
    // Ruta principală (pentru utilizatorii logați)
    path: '/',
    component: MainLayout, // Folosește noul layout
    meta: { requiresAuth: true },
    children: [
      // Acestea sunt paginile care se vor încărca ÎN MainLayout
      {
        path: '', // Default (când ești la '/')
        name: 'EventList',
        component: EventList 
      },
      {
    path: 'news-feed', // Sau 'noutati' - cum vrei tu să fie URL-ul
    name: 'NewsFeed',
    component: NewsFeed
      },
      {
        path: 'my-events',
        name: 'MyEvents',
        component: MyEvents
      },
      {
        path: 'history',
        name: 'PastEvents',
        component: PastEvents
      },
      // Rute de Admin (protejate suplimentar)
      {
        path: 'admin/users',
        name: 'UserManagement',
        component: UserList,
        meta: { requiresAdmin: true }
      },
      {
        path: 'admin/events',
        name: 'EventManagement',
        component: AdminPanel,
        meta: { requiresCoordinator: true }
      },
      {
        path: 'admin/notify',
        name: 'SendNotification',
        component: SendNotification,
        meta: { requiresAdmin: true } // Ruta părinte '/' are deja requiresAuth
      },

      // --- ADAUGĂ ACEST BLOC NOU ---
      {
        path: 'admin/create-post', // URL-ul
        name: 'CreatePost',
        component: CreatePost, // Componenta pe care am creat-o
        meta: { requiresCoordinator: true } // Protejată de admin
      }
      // --- SFÂRȘIT BLOC NOU ---
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// --- Logica de Protecție a Rutelor (Navigation Guard) ---
// (Restul fișierului de aici în jos rămâne neschimbat)
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('userToken');
  let userRole = null;
  
  try {
    const userData = localStorage.getItem('user');
    if (userData) {
      userRole = JSON.parse(userData).role;
    }
  } catch (e) {
    if (isLoggedIn) {
      localStorage.removeItem('userToken');
      localStorage.removeItem('user');
    }
    if (to.meta.requiresAuth) {
       return next({ name: 'Login' });
    }
  }

  if (to.meta.requiresAuth && !isLoggedIn) {
   next({ name: 'Login' });
  } else if (to.meta.requiresGuest && isLoggedIn) {
   next({ path: '/' });

  // --- LOGICĂ NOUĂ AICI ---

   // Regula 1: Pagini doar pentru ADMIN
   } else if (to.meta.requiresAdmin && userRole !== 'admin') {
   // Dacă ruta cere 'admin' și tu NU ești 'admin', te trimite la /
  next({ path: '/' }); 
   
  // Regula 2: Pagini pentru COORDONATOR (și Admin)
  } else if (to.meta.requiresCoordinator && (userRole !== 'admin' && userRole !== 'coordonator')) {
   // Dacă ruta cere 'coordonator' și tu NU ești 'admin' ȘI NICI 'coordonator', te trimite la /
   next({ path: '/' });
   
   // --- SFÂRȘIT LOGICĂ NOUĂ ---

   } else {
   // Dacă ai trecut de toate filtrele, ai voie să intri
   next();
   }
});

export default router;